export default __webpack_public_path__ + "static/media/dateBackground.a5dd2350.svg";